export const AUTH_SUCCESS = 'AUTH-SUCCESS-EVENT-v1';
